export const VERIFICATION = `/verification`;
export const CLIENT_ACCOUNT_VERIFICATION = `/ClientAccountVerification`;
export const CLIENT_ACCOUNT_VERIFICATION_REPORT = `/ClientAccountVerificationReport`;
export const TOKEN_VALIDATION = `/validate-token`;
export const LAW_FIRMS = `/LawFirms`;
